<script>
    import {onDestroy, onMount} from 'svelte';
    import {navigateTo} from 'svelte-router-spa';
	import {PRConnect} from "@projectroom/ui-lib";
	import axios from "axios";
	import { accessToken } from './store/auth-store';
	
    let loading = true; // 로딩 상태
	let url;
	let refIframe;
	let creepongId;
	onMount(() => {
		window.addEventListener("message", (event) => {
			//if (event.origin !== "https://dev-le868-igmigyozkq.user1.projectroom.cloud" && event.origin !== "https://creepong.com" && event.origin !== "https://tsf.creepong.com") return;
			const message = event.data;
			if (message.origin === "avatalk") {
				window.parent.postMessage( {type : message.type, chatId : message.chatId, creepongId, description : message.description }, "*");
				return;
			} 
			// 플러터에 쿠키 세팅을 하고 다시 호출된 message
			if (message.origin === "creepong" && message.isLogin === "success") {
				navigateTargetUrl(message);
				return;
			}
			creepongId = message.creepongId;
			if (!creepongId) {
				// 비회원은 chat-viewer 호출만 있는 상황
				navigateTargetUrl(message);
				return;
			}
			PRConnect.send("/api/Creepong/login", {creepongId}, async (data) => {
				if( data.header.status === "success") {
					const cookie = document.cookie;
					const token = data.result["accessToken"];
					accessToken.set(token);
					const isApp = !!window.__IS_AVATALK_APP;
					if (isApp) {
						window.parent.postMessage( {type : "avatalkLoginTokenSet", name: "x-token", value: token}, "*");
					} else {
						navigateTargetUrl(message);
					}
				}
			});
		});
	});

	const navigateTargetUrl = (message) => {
		const targetUrl = message.targetUrl;
		const chatId = message.chatId;
		const avatalkId = message.avatalkId;
		// AI챗 제작하기 요청
		if (targetUrl === "chat-builder" && !chatId) {
			PRConnect.send("/api/Chat/createChat", {}, data => {
				if( data.header.status === "success") {
					navigateTo(`/chat-builder/${data.result}`);
				}
			});
		// AI챗 수정하기(chatId가 있으면)
		} else if (targetUrl === "chat-builder" && chatId) {
			navigateTo(`/chat-builder/${chatId}`);
		} else if (targetUrl === "chat-viewer") {
			url = `/chat/${chatId}`;
		} else if (targetUrl === "viewer" && avatalkId) {
			url = `/view/${avatalkId}`;
		}
	}
	
	const handleIframeLoad = () => {
		loading = false;
		const message = { creepongId, origin: "avatalk" }; 
		refIframe.contentWindow.postMessage(message, `${window.location.origin}${url}`);
	}

</script>

{#if loading}
<div class="loading-wrapper">
	<div class="loading">
		<div class="start-point"></div>
		<div class="doughnut left"></div>
		<div class="doughnut right"></div>
	</div>
</div>
{/if}
<iframe bind:this={refIframe} src="{url}" frameBorder="0" class="iframe" scrolling="no" referrerpolicy="no-referrer" on:load={handleIframeLoad} style:display={loading ? 'none' : 'block'}/>

<style>
	.iframe {
		width: 100%;
		height: 100vh;
	}
	.loading-wrapper {
		background-color: darkorange;
		width: 100%;
		height: 100vh;
	}
	.loading {
    position: fixed;
    top: 50%;
    left: 50%;
    right: 0;
    bottom: 0;
    display: flex;
    height: 50px;
    width: 50px;
    animation: spin 1s infinite linear;
    margin: -95px 0 0 -25px;
    z-index: 200
	}

	.loading .start-point {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #fff;
		z-index: 1
	}

	.loading .doughnut {
		width: 50%;
		height: 100%;
		box-sizing: border-box;
		mask: linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);
		-webkit-mask: linear-gradient(#fff 0 0) padding-box,linear-gradient(#fff 0 0);
		-webkit-mask-composite: destination-out;
		mask-composite: exclude;
		border: 8px solid rgba(0,0,0,0)
	}

	.loading .doughnut.left {
		border-radius: 25px 0 0 25px;
		background: linear-gradient(to bottom, #fff 100%, transparent) border-box;
		border-right: none
	}

	.loading .doughnut.right {
		border-radius: 0 25px 25px 0;
		background: linear-gradient(to top, #fff 10%, transparent) border-box;
		border-left: none
	}

	@keyframes spin {
		from {
			transform: rotate(0deg)
		}

		to {
			transform: rotate(360deg)
		}
	}
	
</style>